import { combineReducers } from 'redux'
import SectionTypes from 'store/actionTypes/section'
import { createHandleRequest } from './helpers'

const getSections = createHandleRequest(
  SectionTypes.GET_SECTIONS_REQUEST,
  SectionTypes.GET_SECTIONS_SUCCESS,
  SectionTypes.GET_SECTIONS_FAILED
)

const getComponents = createHandleRequest(
  SectionTypes.GET_COMPONENTS_REQUEST,
  SectionTypes.GET_COMPONENTS_SUCCESS,
  SectionTypes.GET_COMPONENTS_FAILED
)

export default combineReducers({
  getSections,
  getComponents
})
